import type { LinkT as RagnarLinkT } from '@mentimeter/ragnar-ui/link';
import { Link as RagnarLink } from '@mentimeter/ragnar-ui/link';
import { EnablePrefetchLink } from '../../utils/EnablePrefetchLink';

export const Link = EnablePrefetchLink<RagnarLinkT>(RagnarLink);

export type LinkT = Parameters<typeof Link>[0];
